import { Button, Grid, Paper, Radio, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs } from '@mui/material'
import { Box, display, width } from '@mui/system'
import { useEffect, useState } from 'react'
import { Item, SuccessPopUp } from '../../../../common/snippets'
import { connect } from 'react-redux'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import {
  BranchRechargesReject,
  GetBranchRechargesListAll,
  updateModal,
  BranchRechargesAccept,
  GetRechargePaymentModesListAll,
  GetBranchRechargeEditRequest,
  updateLoader,
  updateAlertError,
} from '../../../../../store/common/common_action'
import EditIcon from '@mui/icons-material/Edit'
import * as mdt from '../../../../../components/common/modaltypes'
import Datepicker from '../../../../common/datePicker'
import DropDownOA from '../../../../common/dropDownOA'
import moment from 'moment'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { backGroundColorForStatus, isEmpty, focusElemnt, lineInputNavigation2, removeDuplicatesFromArray } from '../../../../common/helper'
import { getBranchHistoryCol, getBranchHistoryColForSTA, getBranchRechargeFilterCol, PdfFooter } from './constant'
import { useTranslation } from '../../../../../i18n/I18nProvider'
import ViewLimitUses from './ViewLimitUses'
import { GetCargoSettingData, getCreditUsageData, getOwnChildBranches } from '../../../../../store/reports/reports_action'
import { GetRequest, PostRequest } from '../../../../common/api'
import { urls } from '../../../../common/constants'
import { BranchRechargesInsertConfirmUpdate, BranchRechargesRejectUpdate, getBranchRechargeAcceptListData } from '../../../../../store/Acounting/acounting_action'
import jsPDF from 'jspdf'
import { callAddFontRobotoBold } from '../../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../../common/font/Roboto-Medium-normal'
import autoTable from 'jspdf-autotable'
import TablePaginationCustom from '../../../../common/TablePagination'
import SuccessAndErrorModal from "../../../../common/SuccessAndErrorModal"
import OTPModal from '../../../BrnchUsrMaster/UserRollRights/OTPModal'
import RechargeRequestCancelRemark from './RechargeRequestCancelRemark'
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { STA_COMPANY_ID } from '../../../../../helper/companyIdhardcode'
import { branchRechargeOTP } from '../../../../common/jotaiState/commonStateAtoms'

const BranchRechargeHistory = (props) => {
  const { translations } = useTranslation()
  const rdcn = translations?.rechargeDebitCreditNote || {}
  const cs = translations?.common || {}
  const branchHistoryCol = getBranchHistoryCol(translations)
  const branchHistoryColForSTA = getBranchHistoryColForSTA(translations)
  const branchRechargeFilterCol = getBranchRechargeFilterCol(translations)
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const {
    data,
    GetBranchRechargesListAll,
    updateModal,
    BranchRechargesReject,
    BranchRechargesAccept,
    GetRechargePaymentModesListAll,
    getOwnChildBranches,
    getBranchRechargeAcceptListData,
    BranchRechargesInsertConfirmUpdate,
    BranchRechargesRejectUpdate,
    updateAlertError, GetCargoSettingData
  } = props
  const { common, reports } = data
  const { generatePDF, load } = { ...state }
  const { loginData, showModal, modalType, roleRights } = common
  const { ownChildBranches1, getCargoSettingData } = reports
  const { intCompanyID, intBranchID } = loginData
  const [rechargeData, setRechargeData] = useState({
    BranchID: 0,
    RechargeID: 0,
    Amount: 0,
    RechargePaymentModeID: 0,
    RechargePaymentModeName: '',
    BankName: 'string',
    InstrumentNo: 'string',
  })
  const [recharge, setRecharge] = useState()
  const [action, setAction] = useState()
  const [refresh, setRefresh] = useState(true)
  const [viewLimit, setViewLimit] = useState(false)
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [tableData, setTableData] = useState([])
  const [sourceCityList, setSourceCityList] = useState([])
  const [selSourceCity, setSelSourceCity] = useState([])
  const [sourceBranchList, setSourceBranchList] = useState([])
  const [selSourceBranch, setSelSourceBranch] = useState([])
  // const [tableData, setTableData] = useState([])
  const [showTable, setShowTable] = useState(true)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [page, setPage] = useState(0)
  const [totalNoOfRows, setTotalNoOfRows] = useState(0)
  const [isSuccess, setIsSuccess] = useState(false)
  const [isSuccess2, setIsSuccess2] = useState(false)
  const [msg, setMsg] = useState('')
  const [resBranchCity, setResBranchCity] = useState([])
  const [OTP, setOTP] = useState("")
  const [handleAcceptData, setHandleAcceptData] = useState({})
  const [branchID, setBranchID] = useState(null)
  const [type, setType] = useState(0)
  const [showModel, setShowModel] = useState(false)
  const [textAreaValue, setTextAreaValue] = useState('')
  const [reportData, setReportData] = useState([])
  const [searchData, setSearchData] = useState({
    CityName: "",
    BranchCode: "",
    BranchName: "",
    PaymentMode: "",
    BankName: "",
    chqNo: "",
    transactionDateTime: '',
    depositDate: '',
    CurrentBalance: '',
    RechargeAmount: '',
    ProcessingFee: '',
    AmountPaid: '',
    ClosingBalance: '',
    RaisedBy: '',
    status: '',
    RejectReason: '',
    AcceptedOrRejectedUser: '',
    AcceptedOrRejectedDateTime: '',
  })
  useEffect(() => {
    if (!isEmpty(loginData)) {
      const obj = {
        intCompanyID: loginData?.intCompanyID,
        intBranchID: loginData?.intBranchID,
        intUserID: loginData?.intUserID
      }
      GetCargoSettingData(obj)
    }
  }, [loginData])
  useEffect(() => {
    let fiterData = reportData?.filter((val) =>
      (searchData?.CityName === "" || (val?.CityName && val?.CityName?.toLocaleLowerCase().includes(searchData?.CityName?.toLocaleLowerCase()))) &&
      (searchData?.BranchCode === "" || (val?.BranchCode && val?.BranchCode?.toString().toLocaleLowerCase().includes(searchData?.BranchCode))) &&
      (searchData?.BranchName === "" || (val?.BranchName && val?.BranchName?.toLocaleLowerCase().includes(searchData?.BranchName?.toLocaleLowerCase()))) &&
      (searchData?.PaymentMode === "" || (val?.PaymentMode && val?.PaymentMode?.toLocaleLowerCase().includes(searchData?.PaymentMode?.toLocaleLowerCase()))) &&
      (searchData?.BankName === "" || (val?.BankName && val?.BankName?.toLocaleLowerCase().includes(searchData?.BankName?.toLocaleLowerCase()))) &&
      (searchData?.chqNo === "" || (val?.chqNo && val?.chqNo?.toString().toLocaleLowerCase().includes(searchData?.chqNo))) &&
      (searchData?.transactionDateTime === "" || (val?.transactionDateTime && val?.transactionDateTime?.toLocaleLowerCase().includes(searchData?.transactionDateTime?.toLocaleLowerCase()))) &&
      (searchData?.depositDate === "" || (val?.depositDate && val?.depositDate?.toLocaleLowerCase().includes(searchData?.depositDate?.toLocaleLowerCase()))) &&
      (searchData?.CurrentBalance === "" || (val?.CurrentBalance && val?.CurrentBalance?.toString().toLocaleLowerCase().includes(searchData?.CurrentBalance))) &&
      (searchData?.RechargeAmount === "" || (val?.RechargeAmount && val?.RechargeAmount?.toString().toLocaleLowerCase().includes(searchData?.RechargeAmount))) &&
      (searchData?.ProcessingFee === "" || (val?.ProcessingFee && val?.ProcessingFee?.toString().toLocaleLowerCase().includes(searchData?.ProcessingFee))) &&
      (searchData?.AmountPaid === "" || (val?.AmountPaid && val?.AmountPaid?.toString().toLocaleLowerCase().includes(searchData?.AmountPaid))) &&
      (searchData?.ClosingBalance === "" || (val?.ClosingBalance && val?.ClosingBalance?.toString().toLocaleLowerCase().includes(searchData?.ClosingBalance))) &&
      (searchData?.RaisedBy === "" || (val?.RaisedBy && val?.RaisedBy?.toLocaleLowerCase().includes(searchData?.RaisedBy?.toLocaleLowerCase()))) &&
      (searchData?.status === "" || (val?.status && val?.status?.toLocaleLowerCase().includes(searchData?.status?.toLocaleLowerCase()))) &&
      (searchData?.RejectReason === "" || (val?.RejectReason && val?.RejectReason?.toLocaleLowerCase().includes(searchData?.RejectReason?.toLocaleLowerCase()))) &&
      (searchData?.AcceptedOrRejectedUser === "" || (val?.AcceptedOrRejectedUser && val?.AcceptedOrRejectedUser?.toLocaleLowerCase().includes(searchData?.AcceptedOrRejectedUser?.toLocaleLowerCase()))) &&
      (searchData?.AcceptedOrRejectedDateTime === "" || (val?.AcceptedOrRejectedDateTime && val?.AcceptedOrRejectedDateTime?.toLocaleLowerCase().includes(searchData?.AcceptedOrRejectedDateTime?.toLocaleLowerCase())))
    );
    setTableData(fiterData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchData]);
  const handleSearchData = (event, field) => {
    let value = event.target.value.toString(); // Convert value to string
    setSearchData({ ...searchData, [field]: value });
  }
  useEffect(() => {
    const obj = {
      intCompanyID,
      intBranchID,
    }
    GetBranchRechargesListAll(obj)
    GetRechargePaymentModesListAll()
    setRefresh(false)
  }, [refresh])
  useEffect(() => {
    if (resBranchCity?.length > 0) {
      const branches = resBranchCity?.map(record => ({
        BranchID: record.BranchID,
        BranchName: record.BranchName,
        CityID: record.CityID,
        CityName: record.CityName,
      }));
      const cities = resBranchCity?.map(record => ({
        CityID: record.CityID,
        CityName: record.CityName,
      }));
      const cityList = removeDuplicatesFromArray(cities, 'CityID')
      const branchList = removeDuplicatesFromArray(branches, 'BranchID')
      setSourceCityList([{ CityName: rdcn.allOption || 'All', CityID: 0 }, ...cityList])
      setSourceBranchList([{ BranchName: rdcn.allOption || 'All', BranchID: 0 }, ...branchList])
    }

  }, [resBranchCity])
  useEffect(() => {
    const loginCity = sourceCityList?.filter((val) => val?.CityID === loginData?.intBranchCityID)
    if (loginCity?.length > 0) {
      setSelSourceCity(loginCity[0])
    } else {
      setSelSourceCity(sourceCityList[0])
      // setSelSourceBranch(sourceBranchList[0])
    }
  }, [sourceCityList])

  useEffect(() => {
    const loginBranch = sourceBranchList?.filter((val) => val?.BranchID === loginData?.intBranchID)
    if (loginBranch?.length > 0) {
      setSelSourceBranch(loginBranch[0])
    } else {
      setSelSourceBranch(sourceBranchList[0])
    }
  }, [sourceBranchList])
  useEffect(() => {
    if (!isEmpty(roleRights)) {
      if (roleRights?.Table1?.[0]?.AllowViewAllBranchReport || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin || loginData?.IsAdmin) {
        const obj = {
          intUserID: 0,
          intCompanyID: loginData?.intCompanyID,
          intBranchID: 0,
          strBranchName: '',
          strBranchCode: '',
          intStateID: 0,
          intCityID: 0,
          intIsActive: -1,
        }
        PostRequest(urls.getBranchConfigOrEwbillinfo, obj).then((res) => {
          if (res.status === 'Success') {
            setResBranchCity(res?.Data?.Table)
          }
        })
        // getBranchConfigOrEwbillinfo(obj)
        // setSourceBranchList(citywiseBranchList)
      } else if (!roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport && roleRights?.Table1?.[0]?.AllowBranchInchargeRights) {
        const obj = {
          CompanyID: loginData?.intCompanyID,
          CityID: loginData?.intCityID,
          UserID: loginData?.intUserID,
          BranchID: loginData?.intBranchID,
          Mode: 1,
        }
        GetRequest(urls.getReportBranchList, obj).then((res) => {
          if (res.status == 'Success') {
            setResBranchCity(res?.Data?.Table)
          }
        })
        // getReportBranchList(obj)
        // setSourceBranchList(reportBranchList)
      } else {
        const obj = {
          intUserID: 0,
          intCompanyID: loginData?.intCompanyID,
          intBranchID: 0,
          strBranchName: '',
          strBranchCode: '',
          intStateID: 0,
          intCityID: loginData?.intCityID,
          intIsActive: -1,
        }
        PostRequest(urls.getBranchConfigOrEwbillinfo, obj).then((res) => {
          if (res.status === 'Success') {
            setResBranchCity(res?.Data?.Table)
          }
        })
        // getBranchConfigOrEwbillinfo(obj)
        // setSourceBranchList(citywiseBranchList)
      }
    }
  }, [roleRights, loginData])
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
  const handleLoadButton = () => {
    // setShowTable(false)
    // setIsPdfLoading(false)
    // if (selVehicle === '' || selVehicle === ' ') {
    //   updateAlertError({ show: true, msg: 'Please select Vehicle No', nextId: 'loadbtn' })
    // } else if (selInclGSTComm === '' || selInclGSTComm === ' ') {
    //   updateAlertError({ show: true, msg: 'Please select Incl. GST on Comm', nextId: 'Incl_GST_Comm' })
    // } else if (selOfflineBooking === '' || selOfflineBooking === ' ') {
    //   updateAlertError({ show: true, msg: 'Please select Offline Booking', nextId: 'Offline_Booking' })
    // } else if (selToPayHamali === '' || selToPayHamali === ' ') {
    //   updateAlertError({ show: true, msg: 'Please select To Pay Hamali', nextId: 'To_Pay_Hamali' })
    // } else {
    const body = {
      CompanyID: loginData?.intCompanyID,
      BranchID: selSourceBranch?.BranchID,
      frmDate: moment(fromDate).format('YYYY-MM-DD'),
      ToDate: moment(toDate).format('YYYY-MM-DD'),
    }
    getBranchRechargeAcceptListData(body).then((res) => {
      updateLoader(false)
      if (res.status === 'Success') {
        const data = res?.Data?.Table?.map((val, index) => ({ ...val, SN: index + 1, transactionDateTime: moment(val?.transactionDateTime).format('DD-MMM-YYYY HH:mm'), AcceptedOrRejectedDateTime: val?.AcceptedOrRejectedDateTime ? moment(val?.AcceptedOrRejectedDateTime).format('DD-MMM-YYYY HH:mm') : '' }))
        setTableData(data || [])
        setReportData(data || [])
        setTotalNoOfRows(2)
        // setShowTable(true)
      } else {
        updateAlertError({ show: true, msg: res?.ErrMessage, nextId: 'loadbtn' })
        // setShowTable(false)
      }
    })
    // }

  }
  const handleAccept = (item) => {
    let CompanyID, BranchID, RechargeID, BranchName;
    if (getCargoSettingData[0].IsRechargeApprovalOTP === 0) {
      ({ CompanyID, BranchID, RechargeID, BranchName } = item);
    } else {
      ({ CompanyID, BranchID, RechargeID, BranchName } = handleAcceptData);
    }
    const obj = {
      intCompanyID: CompanyID,
      intBranchID: BranchID,
      intRechargeID: RechargeID,
      intUserIDRejected: 0,
      intUserIDConfirmed: loginData.intUserID
    }
    BranchRechargesInsertConfirmUpdate(obj).then((res) => {
      if (res.status === 'Success') {
        setMsg(`${BranchName} Recharge Transaction Accepted`)
        setIsSuccess(true)
      } else {
        updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' })
      }
    })
  }
  const handleReject = () => {
    const { CompanyID, BranchID, RechargeID, BranchName } = handleAcceptData
    const obj = {
      intCompanyID: CompanyID,
      intBranchID: BranchID,
      intRechargeID: RechargeID,
      intUserIDRejected: loginData.intUserID,
      RejectReason: textAreaValue
    }
    BranchRechargesRejectUpdate(obj).then((res) => {
      if (res.status === 'Success') {
        setMsg(`${BranchName} Recharge Transaction Rejected`)
        setIsSuccess2(true)
      } else {
        updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' })
      }
    })
  }
  const HeaderData = [
    {
      company: loginData?.strCompanyName,
      fromDate: moment(fromDate).format('YYYY-MM-DD'),
      toDate: moment(toDate).format('YYYY-MM-DD'),
      city: selSourceCity?.CityName,
      branch: selSourceBranch?.BranchName,
    },
  ]
  const sendOTPRequest = (BranchID) => {
    const branchIdToUse = BranchID || branchID;
    const obj = {
      Companyid: loginData?.intCompanyID,
      BranchID: branchIdToUse,
      OTPType: 'BranchRecharge',
      PartyID: 0,
      UserID: loginData?.intUserID,
      OTPDetails: '',
    }
    branchRechargeOTP(obj).then((res) => {
      if (res?.Status == true) {
        setOTP(res.OTP)
        // setOtpModal(true)
        updateModal(true, 'branchRechargeHistoryModel')
      } else {
        setOTP("")
        updateAlertError({ show: true, msg: res.ErrMessage })
      }
    }).catch((err) => {
      updateAlertError({ show: true, msg: err })
      console.log("Error:", err)
    })
  }
  const InsideRowContent = ({ item, index, fontVal }) => {
    return (
      <TableRow className="receivedTr" key={index}>
        <>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left", fontSize: fontVal, textAlign: "center", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}>{item?.SN}</TableCell>
          {/* <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left", fontSize: fontVal,whiteSpace: 'nowrap',overflow: 'hidden',textOverflow: 'ellipsis', }}>{item.CompanyID} </TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left", fontSize: fontVal,whiteSpace: 'nowrap',overflow: 'hidden',textOverflow: 'ellipsis', }}>{item.CompanyName} </TableCell> */}
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left", fontSize: fontVal, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}>{item?.CityName} </TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left", fontSize: fontVal, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}>{item?.BranchCode}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left", fontSize: fontVal, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}>{item?.BranchName}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left", fontSize: fontVal, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}>{item?.PaymentMode}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left", fontSize: fontVal, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}>{item?.BankName}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left", fontSize: fontVal, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}>{item?.chqNo}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left", fontSize: fontVal, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}>{item?.transactionDateTime}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left", fontSize: fontVal, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}>{item?.depositDate}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "right", fontSize: fontVal, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}>{item?.CurrentBalance}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "right", fontSize: fontVal, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}>{item?.RechargeAmount}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "right", fontSize: fontVal, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}>{item?.ProcessingFee}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "right", fontSize: fontVal, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}>{item?.AmountPaid}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "right", fontSize: fontVal, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}>{item?.ClosingBalance}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left", fontSize: fontVal, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}>{item?.RaisedBy}</TableCell>
          <TableCell
            className="reportTD"
            colSpan={1}
            style={{ textAlign: "left", fontSize: fontVal, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: '#1f1f1f', fontWeight: '500' }}
            title={item.status}
          >
            <span
              className="status"
              style={{
                backgroundColor: item.status === 'Accepted' || item.status === 'Auto Accepted' ? '#5fcf23' : item.status === 'Rejected' ? '#F05924' : '#fff2e2',
                padding: '5px 10px',
                borderRadius: '12px',
                whiteSpace: 'nowrap',
              }}
            >
              {item.status}
            </span>
          </TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left", fontSize: fontVal, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}>{item?.RejectReason}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left", fontSize: fontVal, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}>{item?.AcceptedOrRejectedUser}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left", fontSize: fontVal, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}>{item?.AcceptedOrRejectedDateTime}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left", fontSize: fontVal, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Button variant="contained" id="RechargeBtn" style={{ ...sx.fullHeight, ...sx.novp, padding: "5px 20px", background: loginData.intCompanyID === STA_COMPANY_ID && 'green', marginRight: '5px', width: '50px', fontSize: fontVal, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }} className="btn btn-primary"
              // onClick={() => { handleAccept(item.CompanyID, item.BranchID, item.RechargeID,item?.BranchName) }}
              onClick={() => { getCargoSettingData[0].IsRechargeApprovalOTP === 0 ? handleAccept(item) : sendOTPRequest(item.BranchID); setBranchID(item.BranchID); setHandleAcceptData(item); setType(0) }}
              disabled={["Accepted", "Auto Accepted", "Rejected"].includes(item.status)}
            // onKeyDown={(e) => {
            //   navigation1(e, 'select_Payment_Mode', 'CANCEL')
            // }}
            >
              {rdcn.accept || 'ACCEPT'}
            </Button>
            <Button id={"CANCEL"} variant="outlined" sx={{ width: '50px', border: '1px solid #fe5200', background: loginData.intCompanyID === STA_COMPANY_ID && 'red', color: loginData.intCompanyID === STA_COMPANY_ID ? 'white !important' : '#fe5200', fontSize: fontVal, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }} className="receiveitembtn"
              // onClick={() => { handleReject(item.CompanyID, item.BranchID, item.RechargeID,item?.BranchName) }}
              onClick={() => { setShowModel(true); setBranchID(item.BranchID); setHandleAcceptData(item); setType(1) }}
              disabled={["Accepted", "Auto Accepted", "Rejected"].includes(item.status)}
            // onKeyDown={(e) => {
            //   navigation1(e, 'RechargeBtn', 'choose_Receipt')
            // }}
            >
              {rdcn.reject || 'REJECT'}
            </Button>
          </TableCell>
        </>
      </TableRow>
    )
  }
  const printClick = (isSave) => {
    setShowTable(false)
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    // loginData.intCompanyID===STA_COMPANY_ID?
    const headerColoumns = loginData.intCompanyID === STA_COMPANY_ID ? branchHistoryColForSTA : branchHistoryCol
    const pdfColumns = headerColoumns.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const HeaderColumns = branchRechargeFilterCol.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const doc = new jsPDF({ orientation: 'landscape', format: [1156, 1636], unit: 'px', compress: true, });
    var totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `${rdcn.branchRechargeHistory || 'Branch Recharge History'}.pdf`,
      subject: rdcn.branchRechargeHistory || 'Branch Recharge History',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: HeaderData,
      columnStyles: {
        0: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0], },
        1: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0], },
        2: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0], },
        3: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0], },
        4: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0], },

      },
      theme: 'grid',
      startY: 120,
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: 18,
        font: 'Roboto',
        fontStyle: 'normal',
        lineWidth: 0.6,
      },
      didDrawPage: function (data) {
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(18).setFont('Roboto', 'bold')
        // doc.text(
        //   `Booking Date: ${moment(fromDate).format('DD-MMM-YYYY')}  To  ${moment(toDate).format('DD-MMM-YYYY')} `,
        //   data.settings.margin.left,
        //   150
        // )
        // doc.text(`Report View: Detailed`, doc.internal.pageSize.width - data.settings.margin.left, 150, 'right')
      },
    })
    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [191, 225, 255],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'middle',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0],
      },
      tableLineWidth: 0.6,
      columns: pdfColumns,
      body: tableData,
      styles: {
        lineWidth: [0, 0.2, 0, 0.2],
      },
      //---------------data of table-----------
      columnStyles: {
        0: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        1: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        2: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        3: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        4: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        5: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        6: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        7: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        8: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        9: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        10: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        11: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        12: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        13: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        14: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        15: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        16: { halign: 'left', minCellWidth: 100, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        17: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        18: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        19: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
      },
      theme: 'grid',
      // didParseCell: (data) => {
      //     crdeitDrawCellDetail(data)
      // },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text(rdcn.cargoSystemBranchRechargeHistory || 'Cargo System | Branch Recharge History', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont('Roboto', 'bold')
        doc.text(`${cs.companyName || 'Company Name'} :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
        PdfFooter(data, loginData, totalPagesExp, translations)
      },
      // showHead: 'never',
    })
    doc.setFont('Roboto')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`${rdcn.branchRechargeHistory || 'Branch Recharge History'} ${new Date().getTime()}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        document.getElementById('branchRechargeHistory').data = doc.output('datauristring', ` ${rdcn.branchRechargeHistory || 'Branch Recharge History'}.pdf`)
        // focusElemnt('backBtn')
      }, 2000)
    } else {
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        document.getElementById('branchRechargeHistory').data = doc.output('datauristring', ` ${rdcn.branchRechargeHistory || 'Branch Recharge History'}.pdf`)
        // focusElemnt('backBtn')
      }, 2000)
    }
  }
  const clickElement = (elementID) => {
    elementID && document.getElementById(elementID) && document.getElementById(elementID).click()
  }
  const selectedCity = (val) => {
    setSelSourceCity(val)
    if (val.CityID === 0) {
      setSelSourceBranch(sourceBranchList[0]);
    } else {
      let result = resBranchCity?.filter((obj) => obj.CityID === val.CityID || val?.CityID === 0 || obj.BranchID === 0)
      setSourceBranchList([{ BranchID: 0, BranchName: rdcn.allOption || 'All' }, ...result])
      // setSelSourceBranch(sourceBranchList[0]);
    }

  }
  const handleClose = () => {
    setShowModel(false)
  }

  return (
    <>
      {!viewLimit ? <>
        {showTable ?
          <Grid container className='reportButton' sx={{ display: 'flex', flexWrap: 'nowrap', gap: '16px', padding: '12px 15px 4px 15px' }}>
            <Grid item md={1.5}>
              <Item sx={{ ...sx.itemsx }} className="input--container">
                <DropDownOA
                  id={'selectCompany'}
                  label={rdcn.selectCompany || 'Select Company'}
                  defaultvalue={loginData.strCompanyName}
                  disabled={true}
                  // minWidth="10%"
                  width="100%"
                />
              </Item>
            </Grid>
            <Grid item md={1.5}>
              <Item sx={{ ...sx.itemsx }} className="input--container bookingDatePicker">
                <Datepicker
                  label={cs.fromDate || 'From Date'}
                  // name={'from_date'}
                  id={'FromDate'}
                  // value={fromDate}
                  dateChange={(date) => {
                    setFromDate(date)
                    // focusElemnt(id.toDate)
                  }}
                  width="100%"
                // startDate={'2022-01-01'}
                // //startDate={subtractDaysFromDate(moment().format('YYYY-MM-DD'), 365)} //will return previous 1 year date
                // endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)} //will return future 1 year date
                />
              </Item>
            </Grid>
            <Grid item md={1.5}>
              <Item sx={{ ...sx.itemsx }} className="input--container bookingDatePicker">
                <Datepicker
                  label={cs.toDate || 'To Date'}
                  // name={'to_date'}
                  id={'toDate'}
                  // value={toDate}
                  dateChange={(date) => {
                    setToDate(date)
                    // focusElemnt(disableBtn ? id.creditTransSplitButton : id.stateId)
                  }}
                  width="100%"
                // startDate={'2022-01-01'}
                // //startDate={subtractDaysFromDate(moment().format('YYYY-MM-DD'), 365)} //will return previous 1 year date
                // endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)}
                />
              </Item>
            </Grid>
            <Grid item md={1.5}>
              <Item sx={{ ...sx.itemsx }} className="input--container">
                <DropDownOA
                  id={'branchCity'}
                  label={(rdcn.branchCity || 'Branch City').replace('\n', ' ')}
                  data={sourceCityList}
                  defaultvalue={selSourceCity?.CityName}
                  idKey={`CityID`}
                  dataKey={`CityName`}
                  onSelect={(val) => {
                    selectedCity(val)
                  }}
                  isObjArr={true}
                  searchPlaceholder={rdcn.searchByBranchCity || 'Search By Branch City'}
                  width="100%"
                // nextId={id.srcBranch}
                // prevId={id.stateId}
                // resetFlag={resetFlag || resetCity}
                // disabled={disableBtn}
                />
              </Item>
            </Grid>
            <Grid item md={1.9}>
              <Item sx={{ ...sx.itemsx }} className="input--container">
                <DropDownOA
                  id={'srcBranch'}
                  label={(rdcn.branchName || 'Branch Name').replace('\n', ' ')}
                  data={sourceBranchList}
                  defaultvalue={selSourceBranch?.BranchName}
                  idKey={`BranchID`}
                  dataKey={`BranchName`}
                  onSelect={(val) => {
                    // setIsExpanded(false)
                    setSelSourceBranch(val)
                  }}
                  isObjArr={true}
                  searchPlaceholder={rdcn.searchByBranchName || 'Search By Branch Name'}
                  width="100%"
                // nextId={id.creditUsageSplitButton}
                // prevId={id.srcCity}
                // resetFlag={resetFlag || resetCity}
                // disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
                />
              </Item>

            </Grid>
            <Grid item md={0.8}>
              <Item sx={{ ...sx.itemsx }} className="">
                <Button variant="contained" id="RechargeBtn" style={{ ...sx.fullHeight, ...sx.novp, padding: "5px 20px" }} className="btn btn-primary"
                  onClick={handleLoadButton}
                // onKeyDown={(e) => {
                //   navigation1(e, 'select_Payment_Mode', 'CANCEL')
                // }}
                >
                  {cs.load || 'Load'}
                </Button></Item>
            </Grid>
            <Grid item md={1.7}>

              <Button id={"CANCEL"} variant="outlined" className="receiveitembtn"
                onClick={() => setViewLimit(true)}
                // onKeyDown={(e) => {
                //   navigation1(e, 'RechargeBtn', 'choose_Receipt')
                // }}
                style={{ width: '100%' }}
              >
                {rdcn.viewLimitUsages || 'VIEW LIMIT USAGES'}
              </Button>
            </Grid>
            <Grid item md={0.8}>
              <Button id={"CANCEL"} variant="outlined" sx={{ width: '100%' }} className="receiveitembtn"
                onClick={() => printClick(false)}
                // onKeyDown={(e) => {
                //   navigation1(e, 'RechargeBtn', 'choose_Receipt')
                // }}
                style={{ width: '100%' }}
              >
                {rdcn.printUpper || 'PRINT'}
              </Button>
            </Grid>
            <Grid item md={0.8}>

              <Box >
                <Button id='view-xls-button' variant="outlined" sx={{ width: '100%', fontSize: '16px', color: '#fe5200' }} className="receiveitembtn"
                  onClick={(e) => { clickElement('xls-buttons') }}
                  // onKeyDown={(e) => {
                  //   navigation1(e, 'RechargeBtn', 'choose_Receipt')
                  // }}
                  style={{ width: '100%' }}
                >
                  {rdcn.excel || 'EXCEL'}
                </Button>
                <ReactHtmlTableToExcel
                  id="xls-buttons"
                  table="tables"
                  filename={rdcn.branchRechargeHistory || 'Branch Recharge History'}
                  sheet="sheet 1"
                  buttonText={rdcn.exportAsExcel || 'EXPORT AS EXCEL'}
                  className="excel-button"
                />
              </Box>
            </Grid>
          </Grid> : <>
            <Box>
              <Button
                style={{ border: '1px solid #fe5200', color: '#fe5200' }}
                id="backBtn"
                variant="outlined"
                className="userWisereporttembtn"
                onClick={() => (setShowTable(true))}
              >
                {cs.back || 'Back'}
              </Button>
            </Box>
          </>}
        {showTable ?
          <Box sx={{ padding: '12px 15px 4px 15px' }}>
            <TableContainer className="scrollBlue" component={Paper} style={{ overflowX: 'auto', width: '100%', maxHeight: '60vh' }}>
              <Table style={{ width: '100%', tableLayout: 'auto' }} className="table1 table-Report" size="small" aria-label="a dense table">
                <TableHead style={{ position: `sticky`, top: `0`, background: `white`, zIndex: '3' }}>
                  {
                    loginData.intCompanyID === STA_COMPANY_ID ? <>
                      <TableRow style={{ borderRadius: "10px 10px 10px 10px" }}>
                        {branchHistoryColForSTA?.map((item, i) => (
                          <TableCell key={i} style={{ textAlign: item.align, color: "#444444", backgroundColor: "#BFE1FF", whiteSpace: 'pre-line', fontSize: '12px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {item?.headerName}
                          </TableCell>
                        ))}
                      </TableRow>
                      <TableRow>
                        {branchHistoryColForSTA?.map((col, index) => (
                          <TableCell key={`FTH-${index}`} style={{ height: "36px" }}>
                            {index !== 0 && index !== branchHistoryColForSTA?.length - 1 && <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                              <input
                                id={`Contains-${index}`}
                                className="field"
                                name="cancelSearchInput"
                                style={{ width: '100%', height: "24px" }}
                                placeholder={cs.contains || 'Contains'}
                                autoComplete="off"
                                value={searchData[col.field]}
                                onChange={(e) => handleSearchData(e, col.field)}
                              />
                              <FilterAltIcon style={{ color: "#aaa" }} />
                            </div>}
                          </TableCell>
                        ))}
                      </TableRow>
                    </>
                      : <>
                        <TableRow style={{ borderRadius: "10px 10px 10px 10px" }}>
                          {branchHistoryCol?.map((item, i) => (
                            <TableCell key={i} style={{ textAlign: item.align, color: "#444444", backgroundColor: "#BFE1FF", whiteSpace: 'pre-line', fontSize: '12px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                              {item?.headerName}
                            </TableCell>
                          ))}
                        </TableRow>
                        <TableRow>
                          {branchHistoryCol?.map((col, index) => (
                            <TableCell key={`FTH-${index}`} style={{ height: "36px" }}>
                              {index !== 0 && index !== branchHistoryCol?.length - 1 && <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                                <input
                                  id={`Contains-${index}`}
                                  className="field"
                                  name="cancelSearchInput"
                                  style={{ width: '100%', height: "24px" }}
                                  placeholder={cs.contains || 'Contains'}
                                  autoComplete="off"
                                  value={searchData[col.field]}
                                  onChange={(e) => handleSearchData(e, col.field)}
                                />
                                <FilterAltIcon style={{ color: "#aaa" }} />
                              </div>}
                            </TableCell>
                          ))}
                        </TableRow>
                      </>
                  }
                </TableHead>
                {tableData?.length < 1 ? (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={20}>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '20px',
                            marginBottom: '20px',
                            color: 'red',
                            fontSize: '14px',
                          }}
                        >
                          <span>{rdcn.noResultsFoundForFilters || 'No Results Found For The Selected Filters.'}</span>
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody className="filter-data-row"
                    style={{
                      textAlign: 'center',
                      fontSize: '12px',
                      lineheight: '16px',
                      letterspacing: '0.24px',
                      fontWeight: '500',
                      marginLeft: '5px',
                      border: "none"
                    }}
                  >
                    {(
                      rowsPerPage > 0
                        ? tableData.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        ).map((item, index) => (
                          <InsideRowContent item={item} index={index} key={index} fontVal={'12px'} />
                        ))
                        : tableData?.map((item, index) => (
                          <InsideRowContent item={item} index={index} key={index} fontVal={'12px'} />
                        ))
                    )}
                  </TableBody>
                )}
              </Table>
              <Table id="tables" style={{ width: '100%', display: 'none' }} className="table1" size="small" aria-label="a dense table">
                <TableHead style={{ position: `sticky`, top: `0`, background: `white`, display: 'none' }}>
                  <TableRow>
                    <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'left' }} colSpan={10}>
                      <h3 style={{ paddingLeft: '17px' }}>{`Report For: ${rdcn.branchRechargeHistory || 'Branch Recharge History'} -`}</h3>
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'right' }} colSpan={9}>
                      <h3 style={{ paddingLeft: '17px' }}>{`${cs.companyName || 'Company Name'} : ${loginData.strCompanyName}`}</h3>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={19}></TableCell>
                  </TableRow>
                  <TableRow style={{ borderRadius: "10px 10px 10px 10px" }}>
                    {branchRechargeFilterCol?.map((item, i) => (
                      <TableCell key={i} colSpan={item.colSpan} style={{ textAlign: item.align, width: item.minWidth, color: "#444444", backgroundColor: "#BFE1FF", whiteSpace: 'pre-line' }}>
                        {item?.headerName}
                      </TableCell>
                    ))}
                  </TableRow>
                  {HeaderData.map((data, i) => (
                    <TableRow key={i} style={{ borderRadius: "10px" }}>
                      {branchRechargeFilterCol.map((col, j) => (
                        <TableCell
                          colSpan={col.colSpan}
                          key={j}
                          style={{
                            textAlign: col.align,
                            width: col.minWidth,
                            color: "#444444",
                            backgroundColor: "#F5F5F5",
                            whiteSpace: "pre-line",
                          }}
                        >
                          {data[col.field]}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableHead>
                <TableHead style={{ position: `sticky`, top: `0`, background: `white` }}>
                  <TableRow style={{ borderRadius: "10px 10px 10px 10px" }}>
                    {branchHistoryCol?.map((item, i) => (
                      <TableCell key={i} style={{ textAlign: item.align, width: item.minWidth, color: "#444444", backgroundColor: "#BFE1FF", whiteSpace: 'pre-line' }}>
                        {item?.headerName}
                      </TableCell>
                    ))}
                  </TableRow>
                </ TableHead>
                {tableData?.length < 1 ? (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={20}>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '20px',
                            marginBottom: '20px',
                            color: 'red',
                            fontSize: '14px',
                          }}
                        >
                          <span>{rdcn.noResultsFoundForFilters || 'No Results Found For The Selected Filters.'}</span>
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody style={{ border: "none" }}>
                    {(
                      rowsPerPage > 0
                        ? tableData.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        ).map((item, index) => (
                          <InsideRowContent item={item} index={index} key={index} fontVal={'20px'} />
                        ))
                        : tableData?.map((item, index) => (
                          <InsideRowContent item={item} index={index} key={index} fontVal={'20px'} />
                        ))
                    )}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
            <TablePaginationCustom totRowCount={tableData?.length} rowsPerPageOptions={[10, 20, 50, 100, 200, 500]} rowsPerPage={rowsPerPage} page={page} handleChangePage={(event, newPage) => {
              setPage(newPage);
              //  handleLoadButton(newPage, rowsPerPage)
            }} handleChangeRowsPerPage={(event) => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(0);
              // handleLoadButton(0, parseInt(event.target.value, 10))
            }} />
          </Box> : <>
            {generatePDF ? <div style={{ textAlign: 'center' }} className={'generatePDF'}>{cs.pdfGenerationMsg || 'Generating PDF....'}</div> : ''}
            {load ? (
              <object
                id="branchRechargeHistory"
                type="application/pdf"
                width={'100%'}
                height="440"
                title="MTLPL -Cargo System - After Transfer Summary Report"
                aria-label="MTLPL -Cargo System - After Transfer Summary Report"
                style={{ marginTop: '10px', textAlign: 'center' }}
              ></object>
            ) : (
              ''
            )}
          </>}
      </> :
        <ViewLimitUses setViewLimit={setViewLimit} />}
      <SuccessAndErrorModal isError={true} modalStyle={modalStyle} handleClose={() => { setIsSuccess2(false); handleLoadButton(); updateModal(false, 'branchRechargeHistoryModel'); setOTP('') }} open={isSuccess2} title={msg} />
      <SuccessAndErrorModal modalStyle={modalStyle} handleClose={() => { setIsSuccess(false); handleLoadButton(); updateModal(false, 'branchRechargeHistoryModel'); setOTP('') }} open={isSuccess} title={msg} />
      {showModal && 'branchRechargeHistoryModel' === modalType ? <OTPModal saveApi={type === 0 ? handleAccept : handleReject} OTP={OTP} isOpen={isSuccess} setIsOpen={setIsSuccess} sendOTPRequest={sendOTPRequest} /> : null}
      {
        showModel && <RechargeRequestCancelRemark updateModal={handleClose} setShowModel={setShowModel} sendOTPRequest={sendOTPRequest} handleAcceptData={handleAcceptData} loginData={loginData} handleReject={handleReject} setTextAreaValue={setTextAreaValue} getCargoSettingData={getCargoSettingData} />
      }
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  GetBranchRechargesListAll,
  updateModal,
  BranchRechargesReject,
  BranchRechargesAccept,
  GetRechargePaymentModesListAll,
  GetBranchRechargeEditRequest,
  getOwnChildBranches,
  getBranchRechargeAcceptListData,
  BranchRechargesInsertConfirmUpdate,
  BranchRechargesRejectUpdate,
  updateAlertError,
  GetCargoSettingData
}
export default connect(mapStateToProps, mapDispatchToProps)(BranchRechargeHistory)
